import type { Object3D } from "three";
import type { GLTF } from "three/examples/jsm/Addons.js";
import type { Nullable } from "@/types";
import { LINKED_PROPERTIES } from "../resources/constants.ts";
import { getNodes } from "../utils/gltf.ts";

export default class ModelMap {
    readonly #nodes: Map<string, Object3D[]>;

    static #instance: Nullable<ModelMap> = null;

    protected constructor() {
        this.#nodes = new Map();
    }

    static getInstance(): ModelMap {
        ModelMap.#instance ??= new ModelMap();
        return ModelMap.#instance;
    }

    async createFromModel(model: GLTF) {
        this.#nodes.clear();

        const allNodes = await getNodes(model);
        for (const node of allNodes) {
            for (const key of Object.keys(node.userData)) {
                if (key === LINKED_PROPERTIES) continue;

                const previous = this.#nodes.get(key) ?? [];
                previous.push(node);
                this.#nodes.set(key, previous);
            }
        }
    }

    getNodesByProperty(property: string) {
        return this.#nodes.get(property) ?? [];
    }

    getNodeNamesByProperty(property: string) {
        const nodes = this.getNodesByProperty(property);

        const set = new Set<string>();
        for (const node of nodes) {
            set.add(node.name);
        }

        return set;
    }

    destroy() {
        this.#nodes.clear();
    }
}
